// extracted by mini-css-extract-plugin
export default {"brandPromo":"nF-z","carousel":"oF-z"};